import React from "react";
import { FormattedMessage } from "react-intl";
import { useParams } from "react-router-dom";

import { useGetInvoicePaymentStatusQuery } from "~/api";
import { PaymentStatusMessage } from "~/components/common/payment-status-message";
import { Portlet, PortletTitle } from "~/components/ui/portlet";
import { useIntlDocumentTitle } from "~/hooks/use-document-title";
import type { NumericString } from "~/types/common";

import { PageFooter } from "./page_footer";
import { PageHeader } from "./page_header";

export default function PatientPaymentStatus() {
  useIntlDocumentTitle("pat.payments.online.payment");

  const { token, patient_id, invoice_id } = useParams<{
    token: string;
    patient_id: NumericString;
    invoice_id: NumericString;
  }>();

  const invoiceQuery = useGetInvoicePaymentStatusQuery({
    patientId: Number(patient_id),
    invoiceId: Number(invoice_id),
    patientToken: token,
  });

  return (
    <>
      <PageHeader />
      <div className="container">
        <div className="page-container">
          <div className="page-content-wrapper">
            <div className="page-content" style={{ minHeight: 584 }}>
              <div className="row">
                <div className="col-md-8">
                  <Portlet as="main">
                    <PortletTitle iconClassName="icon-book-open">
                      <FormattedMessage id="pat.payments.online.payment" />
                    </PortletTitle>

                    <div className="portlet-body">
                      <PaymentStatusMessage query={invoiceQuery} />
                    </div>
                  </Portlet>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PageFooter />
    </>
  );
}
